import { Typography } from '@mui/material';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import AnimatedSkeletonMultiline from '~/components/AnimatedSkeletonMultiline';
import { CssUtilityType } from '~/styled';
import { SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX } from '~/theme';

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasProgress' && prop !== 'optionalStyles',
})<{
  hasProgress?: boolean;
  optionalStyles?: CssUtilityType;
}>`
  position: relative;
  display: flex;
  flex-direction: ${({ hasProgress }) => (hasProgress ? 'column' : 'row')};
  color: ${({ theme }) => theme.palette.common.gray};
  padding-bottom: ${({ hasProgress }) => (hasProgress ? 44 : 0)}px;
  margin-bottom: ${({ hasProgress }) => (hasProgress ? 24 : 13)}px;
  border-bottom: ${({ hasProgress, theme }) =>
    hasProgress ? `2px solid ${theme.palette.common.blueDark}` : 'none'};

  &:last-child {
    padding-bottom: ${({ hasProgress }) => (hasProgress ? 24 : 0)}px;
    border-bottom: none;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
    padding-bottom: 0;
    border-bottom: none;

    &:last-child {
      padding-bottom: 0;
    }
  }

  ${({ optionalStyles }) => optionalStyles}
`;
export const LeftBlock = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasProgress',
})<{ hasProgress?: boolean }>`
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: bold;
  flex: ${({ hasProgress }) => (hasProgress ? 'unset' : 1)};
  width: ${({ hasProgress }) => (hasProgress ? 'unset' : '100%')};

  & img {
    width: 62px;
    height: 43px;
    object-fit: cover;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 60%;

    & img {
      width: 88px;
      height: 64px;
    }
  }
`;
export const RightBlock = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    width: 35%;
  }
`;
export const LeftBlockInner = styled('div')`
  display: flex;
  align-items: center;
  font-size: 18px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-right: 20px;
  }
`;
export const LoadingTitle = styled(AnimatedSkeletonMultiline)`
  width: 100%;
  max-width: 250px;
  margin-right: ${SUBMIDDLE_MARGIN_PX};
`;
export const LoadingDescription = styled(AnimatedSkeleton)`
  display: none;
  max-width: 150px;
  margin-left: auto;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: block;
  }
`;
export const Title = styled(Typography)`
  overflow: hidden;
  margin: 0;
  display: block;

  &:not(:only-child) {
    margin-bottom: 2px;
  }

  ${({ theme }) => theme.breakpoints.up('ml')} {
    font-size: 20px;
  }
`;
export const StyledLink = styled(Link)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  color: ${({ theme }) => theme.palette.common.white};

  &:hover {
    color: ${({ theme }) => theme.palette.common.blue};
  }
`;
export const ProgressLineWrapper = styled('div')`
  width: 100%;
  margin-top: ${SUBMIDDLE_MARGIN_PX};
  margin-bottom: 0;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 18px;
  }
`;
export const Duration = styled(Typography)`
  margin-left: ${SMALL_MARGIN_PX};
  color: ${({ theme }) => theme.palette.common.gray};
  font-size: 16px;
  line-height: 1;
`;

export const DivGrow = styled('div')`
  flex-grow: 1;
  max-width: calc(
    100% - 96px
  ); //max width is a grown container - 88 px (img size) and - 8 (padding); done in order to truncate the line correctly
`;
